import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import RefEditor from 'saas/common/references/RefEditor';
import _debug from 'debug';
import fetch from 'utils/fetch';
import { error } from 'plugins/toastr';
import { hideLoader } from 'plugins/loader';

require('plugins/forms');
require('plugins/are-you-sure');

const handleErrors = errs => {
  if (errs && Array.isArray(errs)) {
    errs.forEach(err => {
      if (err.name) {
        $(`input[name='${err.name}']`)
          .parent('.field')
          .addClass('error');
      }
    });
  }
};

const handleFormSubmission = refsComponents => {
  let nextAction, nextMethod;

  $('div.actionBar button').on('click', evt => {
    evt.preventDefault();
    const $button = $(evt.target);
    const action = $button.attr('data-action');
    const method = $button.attr('data-method') || 'PUT';

    nextAction = action;
    nextMethod = method;

    displayModal(() => $('section.task-template form').trigger('submit'));
  });

  $('section.task-template form').on('submit', evt => {
    evt.preventDefault();

    const $button = $(document.activeElement);
    const action = $button.attr('data-action') || nextAction;
    const method = $button.attr('data-method') || nextMethod || 'PUT';

    nextAction = null;
    nextMethod = null;

    const $form = $(evt.currentTarget);
    const data = {};

    for (let prop of $form.serializeArray()) {
      data[prop.name] = prop.value || undefined;
    }

    refsComponents.each((_, elem) => {
      const prefix = elem.getPrefix();
      const refs = elem.getLines();
      const createdRefs = refs
        .filter(r => r.id === undefined)
        .map(r => r.label);
      const updatedRefs = refs.filter(r => r.id && r.updated).map(function(r) {
        const id = r.id;
        const label = r.label;
        return { id, label };
      });
      const deletedRefs = elem.getDeletedIds();

      data[prefix + '.newRefs'] = createdRefs;
      data[prefix + '.updatedRefs'] = updatedRefs;
      data[prefix + '.deletedRefs'] = deletedRefs;
    });

    // Submitting
    const url = $form.attr('action');

    // Cleaning up errors on inputs before submitting

    $(`input`)
      .parent('.field')
      .removeClass('error');

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(res => {
        if (action && method) {
          return fetch(action, {
            method,
          });
        } else {
          return Promise.resolve(res);
        }
      })
      .then(res => window.location.replace(res.url))
      .catch(err => {
        console.log('Error attempting to save template', err);

        hideLoader();
        if (err.res.status === 412) {
          err.res.text().then(message => error(message));
        } else {
          error("Une erreur est survenue pendant la sauvegarde de l'activité");
          err.res.json().then(body => handleErrors(body));
        }
      });

    return false;
  });
};

export const edit = ctx => {
  $('.task_template.help').popup({
    popup: '.task_template.popup',
    on: 'click',
    position: 'right center',
    lastResort: 'top left',
    offset: 0,
  });

  $('form.ui.form').areYouSure();

  const $root = $('.refRenderer');
  if ($root && $root.length) {
    // Retrieving context data
    const refs = __INITIAL_DATA__;

    const components = $root.map((_, elem) => {
      const $refContainer = $(elem);
      if (
        $refContainer &&
        $refContainer.length &&
        $refContainer.data('reftype')
      ) {
        const refType = $refContainer.data('reftype');
        const fieldPrefix = $refContainer.data('prefix');
        const buttonLabel = $refContainer.data('buttonlabel');
        const columnLabel = $refContainer.data('columnlabel');

        const refsToUse = refs.filter(
          r => r.reference_type === refType && r.deleted === false
        );

        return ReactDOM.render(
          <RefEditor
            buttonLabel={buttonLabel}
            columnLabel={columnLabel}
            lines={refsToUse}
            prefix={fieldPrefix}
            dirtyFormSupport
          />,
          elem
        );
      } else {
        return undefined;
      }
    });

    handleFormSubmission(components);
  }

  return null;
};

export function displayModal(submitForm) {
  const $modal = $('.modal.confirm-template');

  $modal
    .modal({
      onApprove: element => {
        submitForm();
      },
    })
    .modal('show');
}



// WEBPACK FOOTER //
// ./src/modules/saas/settings/templates/edit.js